import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import * as ENDPOINTS from "constants/endpoints";

import { toastManager } from "components/ToastNotification";

import ButtonContained from "components/ButtonContained";
import SelectInput from "components/SelectInput";
import TextInput from "components/TextInput";

const ServerIndex = ({ onClose }) => {
  const intl = useIntl();
  const theme = useSelector((state) => state.app.theme);

  const [showCustom, setShowCustom] = useState(
    sessionStorage.getItem("nse_url_type") === "custom"
  );
  const [customURL, setCustomURL] = useState(
    sessionStorage.getItem("nse_url") || ""
  );
  const [customVersion, setCustomVersion] = useState(
    sessionStorage.getItem("nse_version") || ""
  );

  const URL_SET = sessionStorage.getItem("nse_url");
  const URL_TYPE = sessionStorage.getItem("nse_url_type");
  const url = window.location.href;

  const handleServerChange = (url, notCustom) => {
    sessionStorage.setItem("nse_url", url);
    toastManager.addToast(`${intl.formatMessage({ id: "notifications.success.server" })} ${url}`)
    if (notCustom) {
      setShowCustom(false);
      setCustomURL(url);
    }
    sessionStorage.setItem("nse_url_type", notCustom ? "server" : "custom");
    onClose();
  };

  const handleVersionChange = () => {
    sessionStorage.setItem("nse_version", customVersion);
    toastManager.addToast(`${intl.formatMessage({ id: "notifications.success.frontend" })} ${customVersion && customVersion !== "" ? customVersion : intl.formatMessage({ id: "pages.schedules.defaultShort" })}`)
    setShowCustom(false);
    onClose();
  };

  return (
    <div className="p-6 space-y-8">
      {url.includes("signin") && (
        <TextInput
          id="server-modal-frontend-version-input"
          dataCy="server-modal-frontend-version-input"
          placeholder={`${intl.formatMessage({ id: "form.releases.frontend" })} ${intl.formatMessage({ id: "comp.footer.version" })}`}
          onChange={(e) => setCustomVersion(e.target.value)}
          value={customVersion}
        />
      )}

      <SelectInput
        id="server-modal-backend-version-select"
        dataCy="server-modal-backend-version-select"
        value={URL_TYPE === "custom" ? "custom" : URL_SET}
        placeholder={`${intl.formatMessage({ id: "form.releases.backend" })} ${intl.formatMessage({ id: "comp.footer.version" })}`}
        onChange={(e) => {
          if (e.target.value === "custom") {
            setShowCustom(true);
            sessionStorage.setItem("nse_url_type", "custom");
          } else {
            handleServerChange(e.target.value, true);
          }
        }}
        options={[
          {
            name: intl.formatMessage({ id: "auth.server.backend" }),
            value: ENDPOINTS.URL_BACKEND,
          },
          {
            name: intl.formatMessage({ id: "auth.server.run" }),
            value: ENDPOINTS.URL_RUN,
          },
          {
            name: intl.formatMessage({ id: "auth.server.dev" }),
            value: ENDPOINTS.URL_BACKEND_DEV,
          },
          {
            name: intl.formatMessage({ id: "auth.server.custom" }),
            value: "custom",
          },
        ]}
      />
      {showCustom && (
        <TextInput
          id="server-modal-custom-version-input"
          dataCy="server-modal-custom-version-input"
          placeholder={intl.formatMessage({ id: "auth.server.custom.url" })}
          onChange={(e) => setCustomURL(e.target.value)}
          value={customURL}
        />
      )}

      <div className="flex justify-end">
        <ButtonContained
          id="server-modal-update-button"
          dataCy="server-modal-update-button"
          text={intl.formatMessage({id: "comp.button.update"})}
          type="default"
          onClick={() => {
            if (showCustom && customVersion.length > 0) {
              handleVersionChange(customURL);
              handleServerChange(customURL);
            } else if (!showCustom) {
              handleVersionChange(customURL);
            } else {
              handleServerChange(customURL);
            }
          }}
        />
      </div>
    </div>
  );
};

export default ServerIndex;